import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why you don't exercise every day",
  "description": "",
  "published": "2012-01-15T00:00:00.000Z",
  "redirect_from": ["/blog/why-you-dont-exercise-every-day/swizec/3456"],
  "categories": "Gym, Motivation, Physical exercise, Richard Branson, Tim Ferriss, Timothy Ferriss, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Because you are an idiot.`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/savelife22.png",
        "alt": "Can you save a life?",
        "title": "Can you save a life?"
      }}></img></p>
    <p>{`But that's harsh, so let me explain why this makes you an idiot. There was `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/item?id=3464853"
      }}>{`an article posted to HN yesterday`}</a>{`about why people don't go to the gym, it included a simple motivational technique of paying yourself to go.`}</p>
    <p>{`After commenting that the only thing it takes to go to the gym every day is `}<em parentName="p">{`to go to the gym every day`}</em>{`, I was downvoted to oblivion. But there's really nothing more to it than that. You can sugar coat it whichever way you want, you can come up with dozens of motivational techniques - in the end, all it takes is going.`}</p>
    <p>{`Even if you don't go to the gym every day, you should still make sure to exercise daily. Here's how you do it:`}</p>
    <ol>
      <li parentName="ol">{`Day 1 - exercise when you wake up`}</li>
      <li parentName="ol">{`Day 2 - exercise when you wake up`}</li>
      <li parentName="ol">{`Day 3 - exercise when you wake up`}</li>
      <li parentName="ol">{`Day 4 - eh you've exercised three days in a row, might as well do it again`}</li>
      <li parentName="ol">{`Day N - do the default thing`}</li>
    </ol>
    <p>{`After a couple of days you have to make a conscius `}<em parentName="p">{`effort`}</em>{` not to exercise. The default action is simply to exercise and as humans we love nothing more than not having to make a decision. This is also known as the `}<a parentName="p" {...{
        "href": "http://theclosetentrepreneur.com/seinfelds-secret-motivational-technique"
      }}>{`Seinfeld motivational technique`}</a>{` by the way.`}</p>
    <p>{`Exercise also does a better job of waking you up than coffee, thought I'd mention that.`}</p>
    <p>{`BUT!`}</p>
    <h2 {...{
      "id": "i-dont-have-time"
    }}>{`I don't have time`}</h2>
    <p><a parentName="p" {...{
        "href": "http://www.crunchbase.com/person/richard-branson",
        "title": "Richard Branson"
      }}>{`Richard Branson`}</a>{` is one of the busiest humans alive, this is what he has to say about exercising daily:`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "http://www.fourhourworkweek.com/",
          "title": "Timothy Ferriss"
        }}>{`Tim Ferriss`}</a>{` tells this story about how Richard Branson was once asked the single biggest thing most people could do to increase productivity. Due to the fact that he's one of the busiest men on the planet, every single person in the audience leaned forward with bated breath. His answer? Exercise daily. It improves the quality of your sleep, so you need less. It makes you more emotionally stable, so you're more motivated. And most importantly, it increases mental clarity, so you're more focused through-out the day. Branson said that it gives him multiple hours more productivity every day. It's bull to say you don't have enough time every day to exercise; if you're that busy then in fact you don't have enough time to NOT exercise.`}</p>
    </blockquote>
    <p>{`And if you're anything like the average person who spends a bunch of time commuting, watching television and browsing the online ... you have no right to complain about lack of time.`}</p>
    <h2 {...{
      "id": "it-cuts-into-family-time"
    }}>{`It cuts into family time`}</h2>
    <p>{`A popular complaint in the HN discussion was that exercise cuts into quality time with their families.`}</p>
    <p>{`Sure ... but one day your building will catch fire, or you'll have a car crash, or `}{`_`}{`something`}{`_`}{`. Can you be there for your family when family time involves saving the people you love from death?`}</p>
    <p>{`No, your flabby office worker muscles won't cut it and that beer+pizza belly won't help either. `}<a parentName="p" {...{
        "href": "http://artofmanliness.com/2009/09/15/every-man-should-be-able-to-save-his-own-life-5-fitness-benchmarks-a-man-must-master/"
      }}>{`Every man should be able to save his life`}</a>{`, and the lives of those he loves! Since this is the 21st century, women should too.`}</p>
    <h2 {...{
      "id": "exercise-is-hard"
    }}>{`Exercise is hard!`}</h2>
    <p>{`Nobody cares. You're fat, you're flabby and you are useless in an emergency. Spending 30 minutes every day doing some basic exercises is `}<em parentName="p">{`nothing`}</em>{` compared to the dividends it pays in pretty much all areas of your life.`}</p>
    <p>{`And if you don't care about any of that, then do it to make the world a prettier place, one flabby human at a time.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.lifehack.org/articles/productivity/how-to-supercharge-your-productivity-the-richard-branson-way.html"
        }}>{`How to Supercharge your Productivity the Richard Branson Way`}</a>{` (lifehack.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.webmd.com/fitness-exercise/features/exercise-motivation?src=RSS_PUBLIC"
        }}>{`Exercise Motivation: How to Get It, How to Keep It`}</a>{` (webmd.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.fitsugar.com/Low-Impact-Exercises-Morning-Workouts-19414062"
        }}>{`5 Low-Impact Exercises to Jump-Start Your Day`}</a>{` (fitsugar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.joyofspa.com/mind-body-exercise-and-emergence"
        }}>{`Mind, Body, Exercise and Emergence`}</a>{` (joyofspa.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://nanapamela.wordpress.com/2012/01/14/some-call-it-cheating-i-call-it-staying-warm-and-dry/"
        }}>{`Some call it cheating. I call it staying warm and dry`}</a>{` (nanapamela.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://coachcalvert.wordpress.com/2012/01/06/exercise-workshop/"
        }}>{`Exercise workshop...`}</a>{` (coachcalvert.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://trainingdaily.runnersworld.com/2012/01/why-exercise-is-healthy-for-mice-at-least/"
        }}>{`Why Exercise Is Healthy...for Mice, at Least`}</a>{` (trainingdaily.runnersworld.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=e93f614a-7984-4f7c-bf86-7653bd2218bd",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      